module.exports = __webpack_public_path__ + "static/media/KH.3b48ae82.png";